import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { TooltipProvider } from '@/components/ui/tooltip';
import { App } from './App.js';
import { AvvisoAggiornamento } from './comuni/AvvisoAggiornamento.js';
import { Notifiche } from './comuni/Notifiche.js';
import { ProviderTema } from './tema/ProviderTema.js';
import './index.css';

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <ProviderTema>
      <TooltipProvider>
        <Notifiche />
        <AvvisoAggiornamento />
        <App />
      </TooltipProvider>
    </ProviderTema>
  </StrictMode>,
);
